"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAcls = void 0;
var IAcls;
(function (IAcls) {
    IAcls["User"] = "user";
    IAcls["Free"] = "free";
    IAcls["Premium"] = "premium";
    IAcls["CoachPlus"] = "coach-plus";
    IAcls["Admin"] = "admin";
})(IAcls || (exports.IAcls = IAcls = {}));
//# sourceMappingURL=acls.js.map